import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { getCookies } from '@pkg-services/cookies/Cookies';

export const authGuard = () => {
  const router = inject(Router);
  if (getCookies('bearer_token')?.length) {
    return true;
  }
  return router.parseUrl('/login');
};

export const authRedirect = () => {
  const router = inject(Router);
  if (!getCookies('bearer_token')?.length) {
    return true;
  }
  return router.parseUrl('/admin');
};
